import React from "react";

export const linkify = inputText => {
  let replacedText;
  let replacePattern1;
  let replacePattern2;
  let replacePattern3;

  replacePattern1 =
    /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(
    replacePattern1,
    '<a href="$1" target="_blank">$1</a>'
  );

  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(
    replacePattern2,
    '$1<a href="http://$2" target="_blank">$2</a>'
  );

  replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(
    replacePattern3,
    '<a href="mailto:$1">$1</a>'
  );

  return (
    <span
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: replacedText }}
      onClick={e => e.stopPropagation()}
    />
  );
};

export const youtubeParser = url => {
  let regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  let match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
};

export const formatString = (string, maxLength) => {
  if (!string) return;
  if (string.length > maxLength) {
    return `${string.substring(0, maxLength)}...`;
  }
  return string;
};

export const getInitials = name => {
  if (!name) return "-";
  return name
    .split(" ")
    .map(word => word.charAt(0))
    .splice(0, 2)
    .join("");
};
